interface BillboardStatusCircleProps {
    color?: string;
    shouldIncludeBorder?: boolean;
    borderColor?: string;
}
export function BillboardStatusCircle({
    color = '#ccc',
    borderColor = '#fff',
}: BillboardStatusCircleProps) {
    const symbol = `
        <symbol id="status-circle" viewBox="0 0 16 16">
            <circle cx="8" cy="8" r="7" stroke-width="2" />
        </symbol>`;

    const use = `
        <use
            href="#status-circle"
            x="232"
            y="232"
            width="64"
            height="64"
            fill="${color}"
            stroke="${borderColor}"
        />`;

    return symbol + use;
}
